module.exports = __webpack_public_path__ + "assets/img/help_next_hover.1cc5618a.svg";